import { useCloudComputingPower } from 'store/src/stores/use-cloud-computing-power'
import { lodashDeepClone, merge } from 'utils'
import ico from '../../assets/image/top-credit/favicon.ico'
import bannerRight from '../../assets/image/top-credit/home/banner-right.png'
import downloadBg from '../../assets/image/top-credit/home/support-platform/download-bg.png'
import logo from '../../assets/image/top-credit/logo-dark.svg'
import { BaseConfig, type BaseConfigSource } from '../common-config'

const primary = '#3C53FF'
const lightPrimary = '#3C53FF'
const secondaryPrimary = '#3C53FF'
const tertiaryPrimary = '#3C53FF'

/** 汇信配置 */
export const HashSpaceDarkConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'light',
  logo: logo,
  platformName: 'HashSpace',
  footerLogo: logo,
  loginShowDownload: true,
  colors: {
    hoverPrimary: primary,
    lightPrimary: lightPrimary,
    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    link: '#3C53FF',
    text: {
      base: '#FFFFFF',
      reverse: '#202630',
      primaryAlt: '#FFFFFF',
      secondary: '#A0A3A7',
      tertiary: '#6A6C75',
    },
    bg: {
      base: '#202630',
      icon: {
        primary: '#EAECEF',
        quaternary: '#A0A3A7',
        secondary: '#A0A3A7',
        trigger: '#16161A',
      },
      button: {
        base: primary,
        primary: primary,
        primaryTextColor: '#fff',
        aux: '#23242A',
        disabled: '#A0A0A0',
      },
      tag: {
        base: '#2B2C35',
      },
      form: {
        base: '#1F2023',
        input: '#1F2023',
        modal: '#2C2C2C',
        card: '#23242A',
      },
      mainPage: {
        base: '#16161A',
        card: '#23242A',
      },
      modal: {
        base: '#252525',
        card: '#23242A',
        shadow: 'rgba(0, 0, 0, 0.10)',
      },
    },
    tip: '#2C2C2C',
    cardBorder: '#4B4D5E',
    divider: '#26272D',
    borderSelected: '#A0A3A7',
    sliderMenu: '#2C2C2C',
  },

  ico,
  header: { boxShadow: 'none', background: '#F5F5F7' },
  home: {
    banner: {
      bannerRight: bannerRight,
    },
    supportPlatform: {
      downloadBg: downloadBg,
    },
  },

  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
} as BaseConfigSource as PlatformConfig)
